import React, { useState, useEffect, useRef, useContext } from "react";
import "../../AccountReports/SchemeReports/SchemeReportDia.css";
import close from "../../../assets/images/close.png";
import SherComboBox from "../../ComboBoxes/SherComboBox";
import axios from "axios";
import headeLogo from "../../../assets/images/shersoftnavLogo.png";
import { AuthContext } from "../../../context/AuthContext";
import { useDbContext } from "../../../context/DbContext";
import { ClipLoader } from "react-spinners";
import { useSelector } from "react-redux";
import { selectActiveFyid } from "../../../app/financialYearSlice";
import { selectActiveLocation } from "../../../app/locationSlice";
import { useActiveFyLimits } from "../../../utils/fyDateValidation";

function ImportReceipt({ fId, onClose }) {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const { dbCode } = useDbContext();
  const { logout, agentCode } = useContext(AuthContext);
  const [isLoading, setIsLoading] = useState(false);
  const tableContainerRef = useRef(null);
  const activeFyid = useSelector(selectActiveFyid);
  const activeLocation = useSelector(selectActiveLocation);
  const fyid = activeFyid || Number(sessionStorage.getItem("selectedFyId")) || Number(localStorage.getItem("selectedFyId")) || 0;
  const locationId = activeLocation?.id || Number(sessionStorage.getItem("loginLocationId")) || Number(localStorage.getItem("loginLocationId")) || 0;

  const [userType, setuserType] = useState("");
  const [userCode, setuserCode] = useState("");
  const [userAccno, setuserAccno] = useState("");
  const [Fid, setFid] = useState("");
  const [fName, setFName] = useState("");
  const customerRef = useRef(null);
  const agentRef = useRef(null);
  const pNoRef = useRef(null);
  const accRef = useRef(null);

  const spinnerProps = {
    color: "#026CC3",
    height: 12,
    width: 5,
    radius: 1,
    margin: 3,
    size: 30,
    speedMultiplier: 0.8,
    css: {
      opacity: "0.8",
    },
  };

  useEffect(() => {
    const storeduType = sessionStorage.getItem("userType");
    if (storeduType) {
      setuserType(storeduType);
      if (storeduType === "CUSTOMERS") {
        const customers = sessionStorage.getItem("CustomerName");
        const accno = sessionStorage.getItem("Uaccno");
        setuserCode(customers);
        setuserAccno(accno);
      }
    }
  }, []);

  const { minDate, maxDate, validateAndAlert, isDateInFy } = useActiveFyLimits();
  const getCurrentDate = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedToday = `${year}-${month}-${day}`;
    // Clamp to active FY limits
    if (minDate && formattedToday < minDate) return minDate;
    if (maxDate && formattedToday > maxDate) return maxDate;
    return formattedToday;
  };
  const initialDateVal = getCurrentDate();

  const [ReportData, setReportData] = useState({
    fromDate: initialDateVal,
    toDate: initialDateVal,
    reportType: "ImportReport",
    agent: "",
    customer: "",
    mobileNo: "",
    accno: { value: "", label: "" },
    cashAcc: { value: "", label: "" },
  });

  const [cRate, setCrate] = useState("");
  const fetchSchCurrentRate = async () => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/getGoldRate/${dbCode}?date=${ReportData.toDate || ""}`
      );
      setCrate(response.data[0]?.currentRate);
    } catch (error) {
      console.error("Error fetching current rate:", error);
    }
  };

  useEffect(() => {
    fetchSchCurrentRate();
  }, [apiBaseUrl, dbCode, ReportData.toDate]);

  const [RegcnameData, setRegCnameData] = useState([]);
  const [agentName, setagentName] = useState([]);
  const [agentobj, setAgentObj] = useState([]);
  const [accNo, setaccNo] = useState([]);
  const [allformdatas, setallformdatas] = useState([]);
  const [selectedForms, setSelectedForms] = useState([]);
  const [tableData, setTableData] = useState([]);

//console.log("tableData=",tableData)

  const [selectedRows, setSelectedRows] = useState([]);
  //console.log("selectedRows==",selectedRows)
  const [selectedcashAcc, setselectedcashAcc] = useState([]);
  const [gmvalue, setGmvalue] = useState("");
  const [expanded, setExpanded] = useState(false);
  const [contentVisible, setContentVisible] = useState(true);

  useEffect(() => {
    const fetchRegCname = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/SchRec_schemeregisteredcustomers/${dbCode}`
        );
        const cName = response.data;
        const transformedData = cName.map((item) => ({ value: item.accname, label: item.LedName }));
        setRegCnameData(transformedData);
      } catch (error) {
        console.error("Error fetching regcustomers Values:", error.message);
      }
    };

    const fetchAgname = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/schsalesmanNames/${dbCode}`
        );
        const AgName = response.data;
        const transformedData = AgName.map((item) => ({ value: item.Auto, label: item.Name }));
        setagentName(transformedData);
      } catch (error) {
        console.error("Error fetching agent Values:", error.message);
      }
    };

    const fetchAccno = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/SchRec_Accno/${dbCode}`
        );
        const Accno = response.data;
        const seenAcc = new Set();
        const transformedData = [];
        (Accno || []).forEach((item) => {
          const numStr = String(item.accno ?? "").trim();
          if (numStr && !seenAcc.has(numStr)) {
            seenAcc.add(numStr);
            transformedData.push({
              value: numStr,
              label: numStr,
              auto: item.auto,
            });
          }
        });
        setaccNo(transformedData);
      } catch (error) {
        console.error("Error fetching accno Values:", error.message);
      }
    };

    const fetchAllformDatas = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/common/selectAllformDatas/${dbCode}`
        );
        const RecData = response.data
          .filter((item) => item.fmrTypeOfVoucher === "SCHEME RECEIPT")
          .map((item) => [item.fmrEntryNo, item.fmrAbbreviation]);
        setallformdatas(RecData);
      } catch (error) {
        console.error("Error fetching forms Values:", error.message);
      }
    };

    const selectcashAcc = async () => {
      try {
        const response = await axios.get(
          `${apiBaseUrl}/main/SchRec_caba/${dbCode}`
        );
        const caba = response.data;
        const filteredData = caba.map((item) => ({ value: item.ledcode, label: item.LedName }));
        setselectedcashAcc(filteredData);
      } catch (error) {
        console.error("Error fetching selectcashAcc Values:", error.message);
      }
    };

    if (dbCode) {
      fetchRegCname();
      fetchAgname();
      fetchAccno();
      fetchAllformDatas();
      selectcashAcc();
    }
  }, [apiBaseUrl, dbCode]);

  const toggleFormSelection = (frmId) => {
    setSelectedForms((prevSelected) =>
      prevSelected.includes(frmId)
        ? prevSelected.filter((id) => id !== frmId)
        : [...prevSelected, frmId]
    );
  };

  const selectAllForms = () => {
    const allFormIds = allformdatas.map((form) => form[0]);
    setSelectedForms(allFormIds);
  };

  const unSelectAllForms = () => {
    setSelectedForms([]);
  };

  const [visibleColumns, setVisibleColumns] = useState({
    accNo: true,
    customer: true,
    entryNo: true,
    type: true,
    amount: true,
    disc: true,
    total: true,
    gm: true,
    discGm: true,
    totalGm: true,
    agent: true,
    date: true,
    schemeName: true,
  });

  const fetchData = async () => {
    const hasAccno = Boolean(
      ReportData.accno?.value ||
      ReportData.accno?.label ||
      (typeof ReportData.accno === "string" && ReportData.accno.trim() !== "")
    );
    const hasCustomer = ReportData.customer?.value || (typeof ReportData.customer === "string" && ReportData.customer.trim() !== "") || (typeof ReportData.customer === "number");

    if (!hasAccno && !hasCustomer) {
      alert("Select Customer");
      return;
    }

    try {
      setIsLoading(true);
      const requestPayload = {
        reportData: { ...ReportData, fyid: fyid, Location: locationId },
        forms: selectedForms,
      };
      const response = await axios.post(
        `${apiBaseUrl}/main/Schrepsimple/${dbCode}`,
        requestPayload
      );
      setTableData(response.data);
      setSelectedRows([]);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const toggleRowSelection = (index) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(index)
        ? prevSelected.filter((i) => i !== index)
        : [...prevSelected, index]
    );
  };

  const selectAllRows = () => {
    setSelectedRows(tableData.map((_, index) => index));
  };

  const clearAllRows = () => {
    setSelectedRows([]);
  };

  const calculateGmValue = (amount) => {
    if (!cRate) return "0.00";
    return (parseFloat(amount) / parseFloat(cRate)).toFixed(4);
  };

  const calculateSelectedTotal = () => {
    return tableData
      .filter((_, index) => selectedRows.includes(index))
      .reduce((total, row) => {
        let amount = 0;
        const val = row.Total !== undefined ? row.Total : row.Amount;
        if (val !== null && val !== undefined) {
          if (typeof val === "string") {
            amount = parseFloat(val.replace(/,/g, "")) || 0;
          } else if (typeof val === "number") {
            amount = val;
          }
        }
        return total + amount;
      }, 0)
      .toFixed(2);
  };

  const handleToggle = () => {
    if (expanded) {
      setContentVisible(true);
      setExpanded(false);
    } else {
      setContentVisible(false);
      setTimeout(() => setExpanded(true), 300);
    }
  };

  const sendSMS = async (
    accountNo,
    mobileNo,
    customerName,
    total,
    grandTotal,
    netwt,
    gm
  ) => {
    try {
      const apiData = await fetchsmssettings("SCHEME RECEIPT");
      if (!apiData || !apiData.MessageBody || !apiData.ApiLink) {
        console.warn("SMS settings not found or incomplete for SCHEME RECEIPT");
        return null;
      }

      const formattedTotal = !isNaN(parseFloat(total)) ? parseFloat(total).toFixed(2) : (total ?? "");
      const formattedGrandTotal = !isNaN(parseFloat(grandTotal)) ? parseFloat(grandTotal).toFixed(2) : (grandTotal ?? "");
      const formattedNetwt = !isNaN(parseFloat(netwt)) ? parseFloat(netwt).toFixed(3) : (netwt ?? "");
      const formattedGm = !isNaN(parseFloat(gm)) ? parseFloat(gm).toFixed(3) : (gm ?? "");

      let message = apiData.MessageBody || "";
      const replacements = {
        "${accountNo}": accountNo ?? "",
        "${customerName}": customerName ?? "",
        "${total}": formattedTotal,
        "${grandTotal}": formattedGrandTotal,
        "${netwt}": formattedNetwt,
        "${gm}": formattedGm,
      };

      Object.keys(replacements).forEach((key) => {
        message = message.split(key).join(replacements[key]);
      });

      const url = apiData.ApiLink
        .split("${mobileNo}").join(mobileNo)
        .split("${encodeURIComponent(message)}").join(encodeURIComponent(message))
        .split("${message}").join(encodeURIComponent(message));

      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error(`Error sending SMS to ${mobileNo}:`, error.message);
      return null;
    }
  };

  const fetchsmssettings = async (eName) => {
    try {
      const response = await axios.get(
        `${apiBaseUrl}/main/selectapidatas/${dbCode}/${eName}?locationId=${activeLocation ? activeLocation.id : ""}`
      );
      return response.data[0];
    } catch (error) {
      console.error("Error fetching smssettings Values:", error.message);
      return null;
    }
  };

  const handleImport = async () => {
    if (selectedRows.length === 0) {
      alert("Please select at least one row to import");
      return;
    }

    if (selectedForms.length === 0) {
      alert("Please select at least one form");
      return;
    }

    if (!window.confirm("Are you sure you want to import the selected receipt(s)?")) {
      return;
    }

    if (isLoading) {
      return;
    }

    try {
      setIsLoading(true);

      const formId = selectedForms[0];
      const selectedData = tableData.filter((_, index) =>
        selectedRows.includes(index)
      );

      const totalAmount = selectedData.reduce((sum, row) => sum + (parseFloat(row.Amount) || 0), 0);
      const totalDisc = selectedData.reduce((sum, row) => sum + (parseFloat(row.Disc) || 0), 0);
      const totalamtdisc = selectedData.reduce((sum, row) => sum + (parseFloat(row.Total) || (parseFloat(row.Amount) || 0) + (parseFloat(row.Disc) || 0)), 0);

      let totalGmVal = selectedData.reduce((sum, row) => sum + (parseFloat(row.Gm) || 0), 0);
      if (totalGmVal === 0 && totalAmount > 0) {
        totalGmVal = parseFloat(calculateGmValue(totalAmount.toFixed(2))) || 0;
      }
      let totalDiscGmVal = selectedData.reduce((sum, row) => sum + (parseFloat(row.DiscGm) || 0), 0);
      let totalTotalGmVal = selectedData.reduce((sum, row) => sum + (parseFloat(row.TotalGm) || 0), 0);
      if (totalTotalGmVal === 0) {
        totalTotalGmVal = totalGmVal + totalDiscGmVal;
      }

      if (!ReportData.cashAcc?.value) {
        alert("Select Cash A/C.");
        return;
      }

      const receiptsToDelete = selectedData.map((row) => ({
        entryNo: row.Entry_No,
        formId: row.FormID,
        ledcode: row.LedCode,
      }));

      const deletePromises = receiptsToDelete.map((receipt) =>
        axios.post(`${apiBaseUrl}/main/deleteImportedReceipt/${dbCode}`, {
          statementType: "deleteFromAccounts",
          entryNo: receipt.entryNo,
          frmid: receipt.formId,
          ledcode: receipt.ledcode,
          fyid: fyid,
          Location: locationId,
        })
      );

      await Promise.all(deletePromises);

      const receiptData = {
        statementType: "SchRec_insert",
        cashacc: ReportData.cashAcc.value,
        schemeId: selectedData[0]?.SchemeId || 0,
        rate: cRate,
        date: getCurrentDate(),
        salesMan: 0,
        totalamount: totalAmount.toFixed(2),
        totalDisc: totalDisc.toFixed(2),
        totalamtdisc: totalamtdisc.toFixed(2),
        totalgm: totalGmVal.toFixed(4),
        totaldiscgm: totalDiscGmVal.toFixed(4),
        agCode: 0,
        formId: fId,
        fyid: fyid,
        Location: locationId,
        type: [
          {
            SINo: 1,
            name: selectedData[0]?.LedCode || 0,
            agent: agentCode,
            accountNumber: selectedData[0]?.SchId || 0,
            amount: totalAmount,
            discount: totalDisc,
            total: totalamtdisc,
            gm: totalGmVal,
            discGm: totalDiscGmVal,
            totalGm: totalTotalGmVal,
            narration: `Import Receipt - ${
              selectedRows.length
            } entries on ${getCurrentDate()}`,
            printgm: 1,
            billed: 1,
            schemeId: selectedData[0]?.SchemeId
          },
        ],
      };

      const response = await axios.post(
        `${apiBaseUrl}/main/saveSchRec/${dbCode}`,
        receiptData
      );

      if (response.data.success) {
        try {
          const accountNumbers = [selectedData[0]?.SchId || 0];
          const mobileNumbersResponse = await axios.post(
            `${apiBaseUrl}/main/fetchMobileNos/${dbCode}`,
            {
              accountNumbers,
            }
          );

          if (
            mobileNumbersResponse.data &&
            mobileNumbersResponse.data.length > 0
          ) {
            const mobileNumber = mobileNumbersResponse.data[0];
            const customerNameData = RegcnameData.find(
              (item) => item.value === selectedData[0]?.LedCode
            );
            const accountNumberData = accNo.find(
              (item) =>
                item.auto === selectedData[0]?.SchId ||
                item.value === selectedData[0]?.SchId ||
                item.label === selectedData[0]?.SchId
            );

            if (mobileNumber && customerNameData && accountNumberData) {
              const smsResponse = await sendSMS(
                accountNumberData.label,
                mobileNumber.mobileNo,
                customerNameData.label,
                totalamtdisc.toFixed(2),
                mobileNumber.totalAmt,
                mobileNumber.totalWt,
                totalTotalGmVal.toFixed(4)
              );
            }
          }

          alert(
            `Receipt imported successfully! Total: ₹${totalamtdisc.toFixed(2)}`
          );
          setSelectedRows([]);
          setSelectedForms([]);
          onClose();
        } catch (deleteError) {
          console.error("Error in post-import operations:", deleteError);
          alert("Receipt imported but failed to complete all operations!");
        }
      } else {
        alert("Failed to import receipt!");
        console.error("Server response:", response.data);
      }
    } catch (error) {
      console.error("Error importing receipt:", error);
      alert("Error importing receipt!");
    } finally {
      setIsLoading(false);
    }
  };

  const renderForms = () => {
    const formGroups = [];
    for (let i = 0; i < allformdatas.length; i += 2) {
      formGroups.push(
        <div key={i} className="w-full flex justify-between mb-2 gap-3">
          {allformdatas[i] && (
            <div className="w-[48%] flex items-center gap-1 ">
              <input
                type="checkbox"
                id={`form-${allformdatas[i][0]}`}
                checked={selectedForms.includes(allformdatas[i][0])}
                onChange={(e) =>
                  toggleFormSelection(allformdatas[i][0], e.target.checked)
                }
                className="h-3 w-3"
              />
              <label
                htmlFor={`form-${allformdatas[i][0]}`}
                className="text-xs text-black font-Poppins  "
              >
                {allformdatas[i][1]}
              </label>
            </div>
          )}
          {allformdatas[i + 1] && (
            <div className="w-[48%] flex items-center gap-1 ">
              <input
                type="checkbox"
                id={`form-${allformdatas[i + 1][0]}`}
                checked={selectedForms.includes(allformdatas[i + 1][0])}
                onChange={(e) =>
                  toggleFormSelection(allformdatas[i + 1][0], e.target.checked)
                }
                className="h-3 w-3"
              />
              <label
                htmlFor={`form-${allformdatas[i + 1][0]}`}
                className="text-xs text-black font-Poppins "
              >
                {allformdatas[i + 1][1]}
              </label>
            </div>
          )}
        </div>
      );
    }
    return formGroups;
  };

  return (
    <div className="bg-[#026CC3] font-Inter w-full h-full rounded-lg shadow-md flex flex-col items-center absolute transition-all duration-300 z-50">
      <style>
        {`
          .tfborder {
            border: 1px solid #d3d1d1;
          }

          .tfborderblack {
            box-sizing: border-box;
            border: 1px solid rgb(18, 59, 105);
          }

          @keyframes fade-in {
            from {
              opacity: 0;
              transform: scale(0.97);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }

          .animate-fade-in {
            animation: fade-in 0.3s ease-in-out;
          }

          .content-transition {
            transition: opacity 0.3s ease-in-out;
          }
        `}
      </style>

      {/* Header */}
      <div className="w-full h-[7.5%] flex rounded-t-lg py-1">
        <div className="w-1/2 h-full flex items-center gap-1 pl-2">
          <img src={headeLogo} alt="SS" />
          <label className="pl-2 text-sm font-medium text-white font-Poppins">
            Import Receipt
          </label>
        </div>
        <div className="w-1/2 h-full flex justify-end items-center gap-2 pr-2">
          <button
            className="rounded px-2 py-1 bg-red-500 border-none h-[25px] w-[25px] flex justify-center items-center"
            onClick={onClose}
          >
            <img src={close} alt="X" className="h-[13px] w-[13px]" />
          </button>
        </div>
      </div>

      <div className="w-full h-full flex bg-white rounded-b-lg items-center justify-center box-border p-4">
        <div className="w-full h-full flex gap-1 transition-all duration-500 ease-in-out">
          {/* Left Section */}
          <div
            className={`transition-all duration-500 ease-in-out tfborder h-full overflow-hidden ${
              expanded ? "w-0" : "w-[40%]"
            }`}
          >
            <div
              className={`w-full h-full flex flex-col box-border py-5 px-2 gap-3 content-transition ${
                contentVisible ? "opacity-100" : "opacity-0"
              }`}
            >
              {/* Inputs Section */}
              <div className="w-full h-auto flex flex-col">
                <div className="w-full h-[30px] flex items-center ">
                  <div className="w-full h-full flex gap-[2%] items-center justify-center">
                    <label
                      htmlFor="from"
                      className="w-[15%] text-black font-Poppins text-[9.39px] font-medium leading-[14px] text-left"
                    >
                      From
                    </label>
                    <div className="w-[83%] h-full flex  justify-between ">
                      <input
                        id="from"
                        type="date"
                        min={minDate}
                        max={maxDate}
                        className="w-[40%] h-[24px] tfborder rounded-none text-sm p-0 m-0"
                        value={ReportData.fromDate}
                        onChange={(e) => {
                          setReportData({
                            ...ReportData,
                            fromDate: e.target.value,
                          });
                        }}
                        onBlur={(e) => {
                          const val = e.target.value;
                          if (val && !isDateInFy(val)) {
                            alert("Date incompatible with financial year");
                          }
                        }}
                      />

                      <label
                        htmlFor="to"
                        className="h-full  text-black font-Poppins text-[9.39px] font-medium leading-[14px] text-center w-full flex items-center justify-center"
                      >
                        To
                      </label>
                      <input
                        id="to"
                        type="date"
                        min={minDate}
                        max={maxDate}
                        className="w-[40%]  h-[24px] tfborder rounded-none text-sm p-0 m-0"
                        value={ReportData.toDate}
                        onChange={(e) => {
                          setReportData({
                            ...ReportData,
                            toDate: e.target.value,
                          });
                        }}
                        onBlur={(e) => {
                          const val = e.target.value;
                          if (val && !isDateInFy(val)) {
                            alert("Date incompatible with financial year");
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="w-full h-[30px] flex items-center gap-[2%]">
                  <label
                    htmlFor=""
                    className="w-[15%] text-black font-Poppins text-[9.39px] font-medium leading-[14px] text-left"
                  >
                    A/C No
                  </label>
                  <SherComboBox
                    comboRef={accRef}
                    options={accNo}
                    value={
                      typeof ReportData.accno === "object"
                        ? ReportData.accno?.label || ReportData.accno?.value || ""
                        : ReportData.accno || ""
                    }
                    onSelect={(opt) =>
                      setReportData((prev) => ({
                        ...prev,
                        accno: opt || { value: "", label: "" },
                      }))
                    }
                    onInputChange={(text) => {
                      setReportData((prev) => ({
                        ...prev,
                        accno: { value: text, label: text },
                      }));
                    }}
                    onFreeInput={(text) => {
                      const match = accNo.find(
                        (o) =>
                          o.label &&
                          o.label.toString().trim().toLowerCase() ===
                            text.trim().toLowerCase()
                      );
                      if (match) {
                        setReportData((prev) => ({
                          ...prev,
                          accno: match,
                        }));
                      } else {
                        setReportData((prev) => ({
                          ...prev,
                          accno: { value: text, label: text },
                        }));
                      }
                    }}
                    onClear={() => {
                      setReportData((prev) => ({
                        ...prev,
                        accno: { value: "", label: "" },
                      }));
                    }}
                    disabled={userType !== "ADMIN"}
                    placeholder="Search account no..."
                    showArrow={true}
                    clearable={true}
                    className="h-[24px] w-[83%]"
                    inputClassName="w-full h-[24px] px-2 bg-white text-[11px] border border-gray-300 rounded-[5px] outline-none focus:border-[#0008a9]"
                  />
                </div>
              </div>

              {/* Form Selection Section */}
              <div className="w-full h-2/5 flex flex-col rounded-md">
                <div className="rounded-t-md h-[40px] bg-[#026CC3] box-border px-2 text-white font-poppins text-xs font-bold leading-normal tracking-normal text-left flex items-center">
                  Select Form
                </div>
                <div className="h-full box-border px-2 py-2 bg-[#F8F8F8] overflow-y-auto">
                  {renderForms()}
                </div>
                <div className="rounded-b-md h-[60px] bg-[#F8F8F8] box-border px-2 text-white font-poppins text-xs font-bold leading-normal tracking-normal text-left flex items-center justify-center gap-4">
                  <button
                    className="w-1/2 h-[24px] flex items-center justify-center rounded-sm text-black font-poppins text-xs font-medium leading-normal tracking-normal tfborderblack"
                    onClick={selectAllForms}
                  >
                    Select All
                  </button>
                  <button
                    className="w-1/2 h-[24px] flex items-center justify-center rounded-sm text-black font-poppins text-xs font-medium leading-normal tracking-normal tfborderblack"
                    onClick={unSelectAllForms}
                  >
                    UnSelect
                  </button>
                </div>
              </div>
              <div className="w-full h-[35px] flex items-center gap-[2%]">
                <label
                  htmlFor=""
                  className="w-[15%] whitespace-nowrap text-black font-Poppins text-[9.39px] font-medium leading-[14px] text-left"
                >
                  CASH A/C
                </label>
                <SherComboBox
                  comboRef={customerRef}
                  options={selectedcashAcc}
                  value={ReportData.cashAcc?.value || ""}
                  onSelect={(opt) =>
                    setReportData({
                      ...ReportData,
                      cashAcc: opt,
                    })
                  }
                  disabled={userType !== "ADMIN"}
                  placeholder="Select cash A/C..."
                  showArrow={true}
                  clearable={true}
                  className="h-[24px] w-[83%]"
                  inputClassName="w-full h-[24px] px-2 bg-white text-[11px] border border-gray-300 rounded-[5px] outline-none focus:border-[#0008a9]"
                />
              </div>

              {/* Action Buttons */}
              <div className="w-full h-1/5 flex items-center justify-center box-border px-2 gap-4">
                <button
                  className="w-1/2 h-[33px] flex items-center justify-center bg-[#026CC3] rounded-sm text-white font-poppins text-xs font-medium leading-normal tracking-normal border-none"
                  onClick={() => {
                    fetchData();
                    handleToggle();
                  }}
                >
                  Show
                </button>
                <button
                  className="w-1/2 h-[33px] flex items-center justify-center bg-[#026CC3] rounded-sm text-white font-poppins text-xs font-medium leading-normal tracking-normal border-none"
                  onClick={handleImport}
                  disabled={isLoading}
                >
                  {isLoading ? "Importing..." : "Import"}
                </button>
              </div>
            </div>
          </div>

          {/* Toggle Button */}
          <div
            onClick={() => {
            if(!expanded)
                    {fetchData();}
              handleToggle();
            }}
            className="w-[5%] h-full bg-[#026CC3] flex items-center justify-center text-white font-poppins text-[9.39px] font-bold leading-[14px] tracking-normal cursor-pointer hover:bg-[#0359a4] transition-colors rounded-sm"
          >
                            {expanded?"HIDE": "SHOW"}

          </div>

          {/* Right Section */}
          <div
            className={`transition-all duration-500 ease-in-out h-full box-border p-3 tfborder ${
              expanded ? "w-[95%]" : "w-[54%]"
            }`}
          >
            {/* Table */}
            <div className="w-full h-full flex flex-col bg-[#D4D4D4]">
              {isLoading ? (
                <div className="flex justify-center items-center h-full w-full">
                  <ClipLoader {...spinnerProps} />
                </div>
              ) : (
                <div
                  className="w-full h-[95%] flex-shrink-0 flex flex-col text-black text-[10px] font-semibold leading-normal overflow-auto"
                  ref={tableContainerRef}
                >
                  <table className="w-full">
                    <thead className="w-full bg-[rgb(2,108,195)] h-[30px] sticky top-0 z-10">
                      <tr className="whitespace-nowrap text-center">
                        <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                          <input
                            type="checkbox"
                            checked={
                              selectedRows.length === tableData.length &&
                              tableData.length > 0
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                selectAllRows();
                              } else {
                                clearAllRows();
                              }
                            }}
                          />
                        </th>
                        {visibleColumns.date && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Date
                          </th>
                        )}
                         {visibleColumns.schemeName && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                           Scheme Name
                          </th>
                        )}
                        {visibleColumns.accNo && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            A/C No
                          </th>
                        )}
                        {visibleColumns.customer && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Customer
                          </th>
                        )}
                        {visibleColumns.entryNo && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Entry No
                          </th>
                        )}
                        {visibleColumns.type && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Type
                          </th>
                        )}
                        {visibleColumns.amount && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Amount
                          </th>
                        )}
                        {visibleColumns.disc && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Disc
                          </th>
                        )}
                        {visibleColumns.total && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Total
                          </th>
                        )}
                        {visibleColumns.gm && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Gm
                          </th>
                        )}
                        {visibleColumns.discGm && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Disc Gm
                          </th>
                        )}
                        {visibleColumns.totalGm && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Total Gm
                          </th>
                        )}
                        {visibleColumns.agent && (
                          <th className="text-white font-inter text-[12px] font-medium leading-[18px]">
                            Agent
                          </th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.map((rowData, rowIndex) => (
                        <tr
                          key={rowIndex}
                          className={`px-1 h-[28px] text-[10px]  ${
                            rowData.atType === "Sub Total"
                              ? "text-red-500"
                              : rowData.atType === "Total"
                              ? "text-blue-500"
                              : selectedRows.includes(rowIndex)
                              ? "bg-blue-200"
                              : ""
                          }`}
                          onClick={() => toggleRowSelection(rowIndex)}
                        >
                          <td className=" border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee]  ">
                            <input
                              type="checkbox"
                              checked={selectedRows.includes(rowIndex)}
                              onChange={(e) => {
                                e.stopPropagation();
                                toggleRowSelection(rowIndex);
                              }}
                              onClick={() => toggleRowSelection(rowIndex)}
                            />
                          </td>
                          {visibleColumns.date && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] whitespace-nowrap text-center">
                              {rowData.Date}
                            </td>
                          )}
                           {visibleColumns.schemeName && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] px-1  w-[5vw]">
                              {rowData.SchemeName}
                            </td>
                          )}
                          {visibleColumns.accNo && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] px-1 text-right w-[5vw]">
                              {rowData.ACC_No}
                            </td>
                          )}
                          {visibleColumns.customer && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] px-1 w-[8vw]">
                              {rowData.Name}
                            </td>
                          )}
                          {visibleColumns.entryNo && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] whitespace-nowrap text-center px-1 w-[2vw]">
                              {rowData.Entry_No}-
                              {rowData.Agent
                                ? rowData.Agent.substring(0, 3)
                                : ""}
                            </td>
                          )}
                          {visibleColumns.type && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] whitespace-nowrap px-1 w-[8vw]">
                              {rowData.Type}
                            </td>
                          )}
                          {visibleColumns.amount && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] px-1 text-right w-[8vw]">
                              {rowData.Amount}
                            </td>
                          )}
                          {visibleColumns.disc && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] px-1 text-right w-[6vw]">
                              {rowData.Disc}
                            </td>
                          )}
                          {visibleColumns.total && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] px-1 text-right w-[8vw]">
                              {rowData.Total}
                            </td>
                          )}
                          {visibleColumns.gm && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] px-1 text-right w-[6vw]">
                              {rowData.Gm}
                            </td>
                          )}
                          {visibleColumns.discGm && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] px-1 text-right w-[6vw]">
                              {rowData.DiscGm}
                            </td>
                          )}
                          {visibleColumns.totalGm && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] px-1 text-right w-[6vw]">
                              {rowData.TotalGm}
                            </td>
                          )}
                          {visibleColumns.agent && (
                            <td className="border-b border-b-[0.1px] border-r border-r-[0.4px] border-[#e8e8e8] bg-[#eeeeee] px-1 w-[8vw]">
                              {rowData.Agent}
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              {selectedRows.length > 0 && (
                <div className="w-auto h-[40px] bg-yellow-100 flex items-center justify-center px-3 text-black font-bold">
                  Total Amount: ₹
                  {selectedRows.length > 0 ? calculateSelectedTotal() : "0.00"}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImportReceipt;